export const TENANT_BACKOFFICE_DENIED_MESSAGE = 'Alunos não podem acessar o backoffice.';

export function canAccessTenantBackoffice(user?: { context?: string | null; roles?: string[] | null } | null): boolean {
  if (!user) {
    return false;
  }

  if (user.context === 'app') {
    return false;
  }

  if (user.context === 'admin' || user.context === 'master') {
    return true;
  }

  return (user.roles ?? []).some(role => role.startsWith('admin:') || role.startsWith('master:'));
}
